import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Menu, X } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Container } from '@/components/generals/container'
import { Logo } from '@/components/generals/logo'

import { MAIN_NAV } from '@/constants/navigation'

export const SiteHeader: FC = (): ReactNode => {
    const router = useRouter()
    const [open, setOpen] = useState(false)

    const isActive = (href: string) =>
        href === '/' ? router.pathname === '/' : router.asPath.split('#')[0].startsWith(href)

    return (
        <header className='sticky top-0 z-50 border-b border-border bg-background/85 backdrop-blur-md'>
            <Container className='flex h-16 items-center justify-between gap-4'>
                <Link href='/' className='shrink-0' aria-label='Smile Design Secret home'>
                    <Logo />
                </Link>

                <nav className='hidden items-center gap-1 lg:flex'>
                    {MAIN_NAV.map(link => (
                        <Link
                            key={link.href}
                            href={link.href}
                            className={cn(
                                'rounded-md px-3 py-2 text-sm font-medium transition-colors',
                                isActive(link.href)
                                    ? 'text-primary'
                                    : 'text-muted-foreground hover:text-foreground'
                            )}
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                <div className='flex items-center gap-2'>
                    <Link
                        href='/#newsletter'
                        className='hidden rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 sm:inline-flex'
                    >
                        Subscribe
                    </Link>

                    <button
                        type='button'
                        onClick={() => setOpen(value => !value)}
                        className='inline-flex size-10 items-center justify-center rounded-md text-foreground hover:bg-secondary lg:hidden'
                        aria-label='Toggle menu'
                        aria-expanded={open}
                    >
                        {open ? <X className='size-5' /> : <Menu className='size-5' />}
                    </button>
                </div>
            </Container>

            {open && (
                <div className='border-t border-border bg-background lg:hidden'>
                    <Container className='flex flex-col py-3'>
                        {MAIN_NAV.map(link => (
                            <Link
                                key={link.href}
                                href={link.href}
                                onClick={() => setOpen(false)}
                                className={cn(
                                    'rounded-md px-3 py-2.5 text-sm font-medium',
                                    isActive(link.href)
                                        ? 'bg-secondary text-primary'
                                        : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                                )}
                            >
                                {link.label}
                            </Link>
                        ))}

                        <Link
                            href='/#newsletter'
                            onClick={() => setOpen(false)}
                            className='mt-2 rounded-md bg-primary px-3 py-2.5 text-center text-sm font-semibold text-primary-foreground'
                        >
                            Subscribe
                        </Link>
                    </Container>
                </div>
            )}
        </header>
    )
}
